import axios from 'axios'
import { apiUrl } from '@/api/base.js'

export default {
    get_library_index () {
        // 包括首页(全部教程)的导航及展示信息。
        // return axios.get(`${apiUrl}v2/library/`)
        // 获取资源分类（即课程总分类）
        return axios.get(apiUrl + "v2/library/categories")
    },
    get_library_content (args) {
        // return axios.get(`${apiUrl}v2/library/books/`, {params: args})
        return axios.get(`${apiUrl}v2/library/documents/`, {params: args})
    },
    get_library_item (args) {
        return axios.get(`${apiUrl}v2/library/document/`, {params: args})
    }
}